import React from "react";
import Select from "./Select";
import JalaliDate, { currentJalali } from "./JalaliDate";

/**
 * field: { name, label, type, required, options, hint, ltr, full, minYear, maxYear, placeholder, disabled }
 * type: text | textarea | date | select | money | nid | mobile | time | password | file
 */
export default function FormFields({ fields, form, setForm, errors = {} }) {
  const set = (name, v) => setForm((f) => ({ ...f, [name]: v }));
  const nowY = currentJalali().jy;

  return (
    <div className="grid2">
      {fields.filter((f) => !f.hidden).map((f) => {
        const err = errors[f.name];
        const v = form[f.name] ?? "";
        const wrapStyle = f.full || f.type === "textarea" ? { gridColumn: "1 / -1" } : undefined;
        let control;
        if (f.type === "custom") return <React.Fragment key={f.name}>{f.render({ form, setForm, errors })}</React.Fragment>;
        switch (f.type) {
          case "textarea":
            control = <textarea value={v} disabled={f.disabled} placeholder={f.placeholder} onChange={(e) => set(f.name, e.target.value)} />;
            break;
          case "select":
            control = (
              <Select value={v} onChange={(x) => set(f.name, x)} options={f.options || []} searchable={(f.options || []).length > 7}
                placeholder={f.placeholder || "انتخاب کنید..."} disabled={f.disabled} />
            );
            break;
          case "date":
            return (
              <div key={f.name} style={wrapStyle}>
                <JalaliDate label={<>{f.label}{f.required && <span className="req">*</span>}</>} value={v}
                  onChange={(x) => set(f.name, x)} error={err} minYear={f.minYear ?? nowY - 5} maxYear={f.maxYear ?? nowY + 2} />
              </div>
            );
          case "file":
            control = (
              <input type="file" accept={f.accept || "application/pdf,image/png,image/jpeg,image/webp"}
                onChange={(e) => set(f.name, e.target.files?.[0] || null)} />
            );
            break;
          default: {
            const numeric = ["money", "nid", "mobile"].includes(f.type);
            control = (
              <input
                type={f.type === "password" ? "password" : f.type === "time" ? "time" : "text"}
                inputMode={numeric ? "numeric" : undefined}
                className={f.ltr || numeric || f.type === "time" || f.type === "password" ? "ltr" : ""}
                value={f.type === "money" && v !== "" ? Number(String(v).replace(/\D/g, "") || 0).toLocaleString("en-US") : v}
                maxLength={f.type === "nid" ? 10 : f.type === "mobile" ? 11 : undefined}
                placeholder={f.placeholder}
                disabled={f.disabled}
                autoComplete={f.type === "password" ? "new-password" : "off"}
                onChange={(e) => set(f.name, e.target.value)}
              />
            );
          }
        }
        return (
          <div className="field" key={f.name} style={wrapStyle}>
            <label>{f.label}{f.required && <span className="req">*</span>}</label>
            {control}
            {f.hint && <div className="hint">{f.hint}</div>}
            {err && <small className="cm-err">{err}</small>}
          </div>
        );
      })}
    </div>
  );
}

export function buildBody(fields, form, multipart) {
  if (!multipart) {
    const o = {};
    for (const f of fields) if (!f.hidden && !f.noBody && f.type !== "file") o[f.name] = form[f.name] ?? "";
    return o;
  }
  const fd = new FormData();
  for (const f of fields) {
    if (f.hidden || f.noBody) continue;
    if (f.type === "file") { if (form[f.name]) fd.append("file", form[f.name]); }
    else fd.append(f.name, form[f.name] ?? "");
  }
  return fd;
}
/** اعتبارسنجی سمت کلاینت (سرور هم دوباره بررسی می‌کند) */
export function validateRequired(fields, form, { editing } = {}) {
  const errors = {};
  for (const f of fields) {
    if (f.hidden || !f.required) continue;
    if (f.type === "custom") {
      const v = form[f.name];
      if (Array.isArray(v) ? !v.length : !v) errors[f.name] = `${f.label} را انتخاب کنید`;
      continue;
    }
    if (f.type === "file") { if (!editing && !form[f.name]) errors[f.name] = `${f.label} را انتخاب کنید`; continue; }
    if (String(form[f.name] ?? "").trim() === "") errors[f.name] = `${f.label} را وارد کنید`;
  }
  return errors;
}